import { __extends } from "tslib";
import { Event } from './Event';
var OutputProgressEvent = /** @class */ (function (_super) {
    __extends(OutputProgressEvent, _super);
    function OutputProgressEvent(type, bubbles, cancelable, bytesPending, bytesTotal) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (bytesPending === void 0) { bytesPending = 0; }
        if (bytesTotal === void 0) { bytesTotal = 0; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.bytesPending = +bytesPending;
        _this.bytesTotal = +bytesTotal;
        return _this;
    }
    OutputProgressEvent.classInitializer = null;
    OutputProgressEvent.classSymbols = null;
    OutputProgressEvent.instanceSymbols = null;
    // JS -> AS Bindings
    OutputProgressEvent.OUTPUT_PROGRESS = 'outputProgress';
    return OutputProgressEvent;
}(Event));
export { OutputProgressEvent };
